document.addEventListener("DOMContentLoaded", () => {
  const firstInputMobile = document.getElementById("first_image_mobile");
  const firstInputDesktop = document.getElementById("first_image_desktop");
  const secondInputMobile = document.getElementById("second_image_mobile");
  const secondInputDesktop = document.getElementById("second_image_desktop");

  const setFistInput = () => {
    if (![firstInputMobile, firstInputDesktop, secondInputMobile, secondInputDesktop].every(Boolean)) return;
    firstInputMobile.checked = true;
    firstInputDesktop.checked = true;
    secondInputMobile.checked = false;
    secondInputDesktop.checked = false;
  };

  const setSecondInput = () => {
    if (![firstInputMobile, firstInputDesktop, secondInputMobile, secondInputDesktop].every(Boolean)) return;
    firstInputMobile.checked = false;
    firstInputDesktop.checked = false;
    secondInputMobile.checked = true;
    secondInputDesktop.checked = true;
  };

  const inicializeImageInputs = () => {
    if (window.show_second_image === true) {
      setSecondInput();
    } else {
      setFistInput();
    }
  };

  inicializeImageInputs();

  initializeColorSwatchesForFilters();
});

function initializeColorSwatchesForFilters() {
  initializeShopCollectionSwatches();
  const colorSwatches = document.querySelectorAll('#CollectionProductGrid .product-card:not(.product-card--shop) .color-swatch[data-product-id]');
  
  if (colorSwatches.length > 0) {
    colorSwatches.forEach(function(swatch) {
      const newSwatch = swatch.cloneNode(true);
      swatch.parentNode.replaceChild(newSwatch, swatch);
      
      newSwatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const productCard = this.closest('.product-card');
        
        const allSwatches = productCard.querySelectorAll('.color-swatch');
        allSwatches.forEach(function(s) {
          s.classList.remove('is-active');
        });
        
        this.classList.add('is-active');
        
        const productId = this.dataset.productId;
        const productPrice = this.dataset.productPrice;
        const productCompareAtPrice = this.dataset.productCompareAtPrice;
        const productTitle = this.dataset.productTitle;
        const productImage = this.dataset.productImage;
        const productSecondImage = this.dataset.productSecondImage;
        const productUrl = this.dataset.productUrl;
        
        const firstImageTrigger = productCard.querySelector('.first-image-trigger');
        if (firstImageTrigger && productImage) {
          firstImageTrigger.src = productImage;
          firstImageTrigger.removeAttribute('srcset');
        }
        
        const secondImageTrigger = productCard.querySelector('.second-image-trigger');
        if (secondImageTrigger) {
          secondImageTrigger.src = productSecondImage || productImage;
          secondImageTrigger.removeAttribute('srcset');
        }
        
        const priceContainer = productCard.querySelector('.product-card__price');
        if (priceContainer && productPrice) {
          let priceHtml = '';
          if (productCompareAtPrice && parseFloat(productCompareAtPrice) > parseFloat(productPrice)) {
            priceHtml = `
              <span class="product-card__price--sale">
                ${formatMoneyForFilters(productPrice)} kr.
              </span>
              <span class="product-card__price--compare">
                ${formatMoneyForFilters(productCompareAtPrice)} kr.
              </span>
            `;
          } else {
            priceHtml = `
              <span class="product-card__price--regular">
                ${formatMoneyForFilters(productPrice)} kr.
              </span>
            `;
          }
          priceContainer.innerHTML = priceHtml;
        }
        
        const titleElement = productCard.querySelector('.product-card__title');
        if (titleElement && productTitle) {
          titleElement.textContent = productTitle;
        }
        
        const productLinks = productCard.querySelectorAll('a:not(.color-swatch)');
        productLinks.forEach(function(link) {
          link.href = productUrl;
        });
      });
    });
  }
}

let collectionSwatchResizeObserver;

function updateCollectionSwatchHint(row) {
  const remaining = row.scrollWidth - row.clientWidth - row.scrollLeft;
  row.closest('.product-card-color-selector').classList.toggle('has-more-colors', row.clientWidth > 0 && remaining > 1);
}

function initializeShopCollectionSwatches() {
  const grid = document.querySelector('#CollectionProductGrid.collection-grid--shop');
  if (!grid) return;

  const rows = grid.querySelectorAll('.product-card-color-selector .color-swatches');
  if (collectionSwatchResizeObserver) collectionSwatchResizeObserver.disconnect();
  if (typeof window.ResizeObserver === 'function') {
    collectionSwatchResizeObserver = new window.ResizeObserver(entries => {
      entries.forEach(entry => updateCollectionSwatchHint(entry.target));
    });
    rows.forEach(row => collectionSwatchResizeObserver.observe(row));
  }
  rows.forEach(row => {
    if (!row.dataset.hintInitialized) {
      row.dataset.hintInitialized = 'true';
      row.addEventListener('scroll', () => updateCollectionSwatchHint(row), { passive: true });
    }
    updateCollectionSwatchHint(row);
  });

  if (grid.dataset.shopSwatchesInitialized) return;
  grid.dataset.shopSwatchesInitialized = 'true';
  // Delegation keeps buttons and keyboard focus intact after filtering or sorting.
  grid.addEventListener('click', event => {
    const swatch = event.target.closest('.product-card--shop .color-swatch[data-product-id]');
    if (!swatch || !grid.contains(swatch)) return;
    event.preventDefault();
    event.stopPropagation();
    selectShopCollectionColor(swatch, grid);
  });
}

function selectShopCollectionColor(swatch, grid) {
  const card = swatch.closest('.product-card');
  const data = swatch.dataset;
  if (!card || !data.productImage || !data.productUrl) return;

  const status = grid.querySelector('.collection-card-status');
  const request = String(Number(card.dataset.swatchRequest || 0) + 1);
  card.dataset.swatchRequest = request;
  card.setAttribute('aria-busy', 'true');
  if (status) {
    status.classList.remove('collection-card-status--error');
    status.textContent = '';
  }

  const image = new Image();
  image.onload = () => {
    if (!card.isConnected || card.dataset.swatchRequest !== request) return;
    card.removeAttribute('aria-busy');
    card.querySelectorAll('.color-swatch').forEach(item => {
      const selected = item === swatch;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', String(selected));
    });

    ['.first-image-trigger', '.second-image-trigger'].forEach((selector, index) => {
      const element = card.querySelector(selector);
      if (!element) return;
      element.src = index === 0 ? data.productImage : data.productSecondImage || data.productImage;
      element.removeAttribute('srcset');
      element.alt = data.productTitle || '';
    });
    const parts = (data.productTitle || '').replace(/ – /g, ' - ').split(' - ');
    const title = card.querySelector('.product-card__title');
    const detail = card.querySelector('.product-card__detail');
    if (title) title.textContent = parts.shift();
    if (detail) detail.textContent = parts.join(' · ');

    // Use Liquid-rendered prices to preserve member discounts and price prefixes.
    const price = card.querySelector('.product-card__price');
    if (price && data.priceHtml !== undefined) price.innerHTML = data.priceHtml;
    const badges = card.querySelector('.tag-container');
    if (badges && data.badgesHtml !== undefined) badges.innerHTML = data.badgesHtml;
    const logo = card.querySelector('.brand-logo-collection');
    if (logo) {
      logo.hidden = !data.productLogo;
      if (data.productLogo) logo.src = data.productLogo;
      else logo.removeAttribute('src');
      logo.alt = data.productVendor || '';
    }
    card.querySelectorAll('a').forEach(link => { link.href = data.productUrl; });
    if (status) status.textContent = `${data.productTitle} valgt.`;
  };
  image.onerror = () => {
    if (!card.isConnected || card.dataset.swatchRequest !== request) return;
    card.removeAttribute('aria-busy');
    if (status) {
      status.classList.add('collection-card-status--error');
      status.textContent = 'Vi kunne ikke hente denne farve. Prøv igen.';
    }
  };
  image.src = window.show_second_image && data.productSecondImage ? data.productSecondImage : data.productImage;
}

if (typeof window.ResizeObserver !== 'function') {
  window.addEventListener('resize', () => {
    document.querySelectorAll('.collection-grid--shop .color-swatches').forEach(updateCollectionSwatchHint);
  });
}
document.addEventListener('shopify:section:load', initializeColorSwatchesForFilters);
document.addEventListener('shopify:section:unload', event => {
  if (collectionSwatchResizeObserver && event.target.querySelector('#CollectionProductGrid.collection-grid--shop')) {
    collectionSwatchResizeObserver.disconnect();
  }
});

function formatMoneyForFilters(cents) {
  const amount = parseFloat(cents) / 100;
  return amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
}

